/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import { literal } from '../../util.type';

/**
 * Časovač ve starém formátu.
 * @deprecated Tento starý formát se již nepoužívá.
 * Ponecháno pouze pro umožnění smazání.
 */
export default {
  name: literal('timer')
};
